let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2DYnJ")).then(() => parcelRequire('SedUr'));